import React, { useEffect, useRef, useState } from 'react'
import BorderHeading from '../../components/heading/BorderHeading'
import ConfigurationHeader from '../../components/heading/ConfigurationHeader'
import { configurationAttributeType, defaultLanguageConfiguationValues, languageOptions, newConfigurationNames } from '../../types'
import "./LanguageConfiguration.css"
import { doFinalConfigSubmit, getMetaDataConfig, getNewConfiguration, overWriteConfig, postConfiguration, updateConfiguration } from '../../services/uiConfigService'
import store from '../../stateManagement/store'
import * as Sentry from "@sentry/react";
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions'
import { openPopup } from '../../stateManagement/actions/popupActions'
import { config } from 'process'
import { DashboardCheckbox } from '../../components/Input/Input'
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes'
import { deepClone } from '@mui/x-data-grid/utils/utils'
import ConfigComparePopup from '../../components/popup/ConfigComparePopup'
import ImportConfig from '../../components/importConfig/ImportConfig'

export const defaultOptions:defaultLanguageConfiguationValues = {
  supportedLanguages:{
    "name": "supportedLanguages",
    "type": "list",
    "value": [
      {
        "code": "en",
        "origin": "English",
        "language": "English"
      }
    ],
    "docUrl": "",
    "description": "language configuration",
    "possibleVals": [
      {
        "code": "en",
        "origin": "English",
        "language": "English"
      },
      {
        "code": "hi",
        "origin": "हिन्दी",
        "language": "Hindi"
      },
      {
        "code": "hie",
        "origin": "Hinglish",
        "language": "Hinglish"
      },
      {
        "code": "pa",
        "origin": "ਪੰਜਾਬੀ",
        "language": "Punjabi"
      },
      {
        "code": "ta",
        "origin": "தமிழ்",
        "language": "Tamil"
      },
      {
        "code": "te",
        "origin": "తెలుగు",
        "language": "Telugu"
      },
      {
        "code": "ml",
        "origin": "മലയാളം",
        "language": "Malayalam"
      },
      {
        "code": "kn",
        "origin": "ಕನ್ನಡ",
        "language": "Kannada"
      },
      {
        "code": "mr",
        "origin": "मराठी",
        "language": "Marathi"
      },
      {
        "code": "bn",
        "origin": "বাংলা",
        "language": "Bengali"
      },
      {
        "code": "as",
        "origin": "অসমীয়া",
        "language": "Assamese"
      },
      {
        "code": "gu",
        "origin": "ગુજરાતી",
        "language": "Gujarati"
      },
      {
        "code": "id",
        "origin": "Bahasa",
        "language": "Bahasa"
      },
      {
        "code": "zh",
        "origin": "中文",
        "language": "Mandarin"
      },
      {
        "code": "de",
        "origin": "German",
        "language": "German"
      },
      {
        "code": "es",
        "origin": "Spanish",
        "language": "Spanish"
      },

      {
        "code": "fr",
        "origin": "Française",
        "language": "French"
      },
      {
        "code": "it",
        "origin": "Italian",
        "language": "Italian"
      },
      {
        "code": "ja",
        "origin": "Japanese",
        "language": "Japanese"
      },
      {
        "code": "nl",
        "origin": "Dutch",
        "language": "Dutch"
      },
      {
        "code": "vi",
        "origin": "Vietnamese",
        "language": "Vietnamese"
      },
      {
        "code": "my",
        "origin": "မြန်မာ",
        "language": "Burmese"
      },
      {
        "code": "ne",
        "origin": "नेपाली",
        "language": "Nepali"
      },
      {
        "code": "km",
        "origin": "Khmer",
        "language": "Khmer"
      },
      {
        "code": "or",
        "origin": "ଓଡିଆ",
        "language": "Oriya"
      },
      {
        "code": "tl",
        "origin": "Tagalog",
        "language": "Tagalog"
      },
      {
        "code": "ar",
        "origin": "عربي",
        "language": "Arabic"
      },
      {
        "code": "pt",
        "origin": "Português",
        "language": "Portuguese"
      }
    ]
  }
}


const LanguageConfiguration = () => {
  const [languageConfig, setLanguageConfig] = useState<configurationAttributeType<languageOptions[]>[]>([]);
  const [values, setValues] = useState<defaultLanguageConfiguationValues>(deepClone(defaultOptions))

  const getLanguageConfiguration = async () => {
    try {
      const resp = await getNewConfiguration('multi_lingual_configuration');
      const language_config: configurationAttributeType<languageOptions[]>[] = resp?.domainValues;
      const supportedLanguages = language_config.find(config=>config.name === "supportedLanguages");
      values.supportedLanguages.value = supportedLanguages ? [...supportedLanguages.value] : values.supportedLanguages.value;
      setLanguageConfig(language_config)
      setValues({...values});
    } catch (err) {
      // Sentry.captureException(err);
    }
  }
  useEffect(() => {
    getLanguageConfiguration();
  }, [])

  const saveConfiguration = async (preview?: boolean) => {

      try {
        let result = {...values};
        const convertedVals = [...languageConfig];
        Object.keys(result).forEach(key=>{
          const languageObject = convertedVals.find(config=>config.name === key)
          if(languageObject){
            languageObject.value = result[key].value;
          }else{
            convertedVals.push(result[key]);
          }
        })
        await doFinalConfigSubmit("multi_lingual_configuration",convertedVals);
      } catch (err) {
        // Sentry.captureException(err);
        console.log("err===", err)
        openPopup('Error',"Validation Error occured")
      }
  }

  const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>)=>{
    const updatedValues = [...values.supportedLanguages.value];
    if(event.target.checked){
      updatedValues.push({...values.supportedLanguages.possibleVals.find(languageObject=>languageObject.code === event.target.name)})
      values.supportedLanguages.value = updatedValues;
      setValues({
        ...values
      })
    }else{
      values.supportedLanguages.value = updatedValues.filter(languageObject=>languageObject.code !== event.target.name);
      setValues({
        ...values
      })
      
    }
  }
  

  const importConfiguration = async (importedConfig:any)=>{
    const newConfigs = await overWriteConfig(importedConfig, {
        multi_lingual_configuration:"importAll"
    })
    for(const configObject of newConfigs){
        await doFinalConfigSubmit(configObject.domainType, configObject.domainValues)
    }
    getLanguageConfiguration();
  }
  const [importConfigState,setImportConfigState] = useState(false);



  return (
    <div className="language_config_container">
      <ImportConfig importConfigState={importConfigState} setImportConfigState={setImportConfigState} configNames={['multi_lingual_configuration']} importConfigCallback={importConfiguration} />
      <ConfigurationHeader heading={"Language Configuration"} importConfiguration={()=>{setImportConfigState(true)}} saveConfiguration={() => saveConfiguration(false)} showConfirmPopup={true} />
      <div className="config_form_container">
        <div className="form_header">
          <BorderHeading>Select the language options to be enabled</BorderHeading>
        </div>
        <div className="language_options_container">
          {values.supportedLanguages && values.supportedLanguages.possibleVals.map(languageObject=>{
            return (
              <DashboardCheckbox 
                onChange={handleCheckChange} 
                checked={values.supportedLanguages.value.map(option=>option.code).includes(languageObject.code)} 
                name={languageObject.code} 
                label={languageObject.language}
              />
            );
          })}
        </div>
      </div>
    </div>
  )
}

export default LanguageConfiguration